import { Action } from '@ngrx/store';
import { TableFilter } from '../models/table-filter.model';

export enum ActionTypes {
    FETCH_PAGES         = '[Financial Documents Table] Fetch Pages',
    FETCH_PAGES_SUCCESS = '[Financial Documents Table] Fetch Pages Success',
    ACTIVATE_PAGE       = '[Financial Documents Table] Activate Page',

    LOAD_COLUMNS            = '[Financial Documents Page] Load Columns',
    ADD_COLUMNS             = '[Financial Documents Page] Add Columns',
    SHOW_COLUMNS            = '[Financial Documents Page] Show Columns',
    HIDE_COLUMNS            = '[Financial Documents Page] Hide Columns',
    ADD_FILTER              = '[Financial Documents Page] Add Filter',
    REMOVE_FILTER           = '[Financial Documents Page] Remove Filter',
    ADD_DATE_FILTER         = '[Financial Documents Page] Add Date Filter',
    REMOVE_DATE_FILTER      = '[Financial Documents Page] Remove Date Filter',
    ADD_FILTERS             = '[Financial Documents Page] Add Filters',
    REMOVE_FILTERS          = '[Financial Documents Page] Remove Filters',
    CLEAR_FILTERS           = '[Financial Documents Page] Clear Filters',
}

export class FetchPages implements Action {
    readonly type: string = ActionTypes.FETCH_PAGES;

    constructor(public payload?: any) {}
}

export class FetchPagesSuccess implements Action {
    readonly type: string = ActionTypes.FETCH_PAGES_SUCCESS;

    constructor(public payload: number) {}
}

export class ActivatePage implements Action {
    readonly type: string = ActionTypes.ACTIVATE_PAGE;

    constructor(public payload: number) {}
}






export class LoadColumns implements Action {
    readonly type: string = ActionTypes.LOAD_COLUMNS;

    constructor(public payload?: any) {}
}

export class AddColumns implements Action {
    readonly type: string = ActionTypes.ADD_COLUMNS;

    constructor(public payload: {[key: string]: boolean}) {}
}

export class ShowColumns implements Action {
    readonly type: string = ActionTypes.SHOW_COLUMNS;

    constructor(public payload: string[]) {}
}

export class HideColumns implements Action {
    readonly type: string = ActionTypes.HIDE_COLUMNS;

    constructor(public payload: string[]) {}
}

export class AddFilter implements Action {
    readonly type: string = ActionTypes.ADD_FILTER;

    constructor(public payload: TableFilter) {}
}

export class RemoveFilter implements Action {
    readonly type: string = ActionTypes.REMOVE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class AddDateFilter implements Action {
    readonly type: string = ActionTypes.ADD_DATE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class RemoveDateFilter implements Action {
    readonly type: string = ActionTypes.REMOVE_DATE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class AddFilters implements Action {
    readonly type: string = ActionTypes.ADD_FILTERS;

    constructor(public payload: TableFilter[]) {}
}

export class RemoveFilters implements Action {
    readonly type: string = ActionTypes.REMOVE_FILTERS;

    constructor(public payload: string) {}
}

export class ClearFilters implements Action {
    readonly type: string = ActionTypes.CLEAR_FILTERS;

    constructor(public payload?: any) {}
}

export type Actions =
    | FetchPages | FetchPagesSuccess
    | ActivatePage
    | AddFilter
    | RemoveFilter
    | AddDateFilter
    | RemoveDateFilter
    | AddFilters
    | RemoveFilters
    | ClearFilters
    | LoadColumns
    | AddColumns
    | ShowColumns
    | HideColumns;
